module.exports = __webpack_public_path__ + "img/framenew_box13.695ef61b.jpg";